export default {
    PtFieldManagerPanel: {
        avaliableFields: 'オプションフィールド',
        displayFields: '表示フィールド',
        patentFields: '特許フィールド',
        customFields: 'カスタムフィールド',
        searchPlaceholder: 'フィールドを検索',
        noData: '現在のタイプのフィールドがありません',
        searchNoData: '関連フィールドが見つかりませんでした',
        spaceScopeFieldTip: '✏️Index value is limited to current workspace',
    },
};
